import { FC } from 'react';
import { Skeleton } from '@gravity-ui/uikit';
import { ClipboardTextfield } from '../../ui/ClipboardTextfield/ClipboardTextfield';

type InsertionCodeFieldProps = {
    loading?: boolean;
    text: string;
};

export const InsertionCodeField: FC<InsertionCodeFieldProps> = ({ loading, text }) => {
    return (
        <>
            {loading ? (
                <Skeleton
                    style={{
                        width: '100%',
                        height: '52px',
                        borderRadius: '8px',
                    }}
                />
            ) : (
                <ClipboardTextfield text={text} widthInLines={2} />
            )}
        </>
    );
};
